import React from "react";
import AdminCrud from "@/components/AdminCrud";

export default function AdminBanners() {
  return (
    <AdminCrud
      title="Banners da Home"
      resource="banners"
      initialItem={{ status: "published", order: 0, text_color: "" }}
      fields={[
        { name: "title", label: "Título", required: true },
        { name: "subtitle", label: "Subtítulo", textarea: true, rows: 2 },
        { name: "image_url", label: "Imagem do banner", type: "image", required: true },
        { name: "text_color", label: "Cor do texto (opcional)", type: "color", help: "Deixe vazio para usar a cor padrão do tema (ivory sobre imagem)" },
        { name: "cta_label", label: "Texto do botão" },
        { name: "cta_link", label: "Link do botão" },
        { name: "order", label: "Ordem", type: "number" },
      ]}
      columns={[
        { name: "title", label: "Título" },
        { name: "cta_label", label: "CTA" },
        { name: "order", label: "Ordem" },
      ]}
    />
  );
}
